// Highway-fade — pure mastery-driven crutch fade (the "challenge" axis).
// Returns members of the shared reading-fade ladder [0, 0.33, 0.66, 1] (see
// engine/coach-escalation.ts READING_RUNGS) so the Coach feed can walk them back
// up on a stumble. A leaf module: no imports. See
// docs/superpowers/specs/2026-06-20-memory-fade-challenge-design.md.

/** Highway opacity for a song mastered `fraction` (0..1) of the way through its
 *  bars. Full mastery → 0 (play from memory); 0 is reserved for complete mastery. */
export function masteryFadeOpacity(fraction: number): number {
  if (fraction >= 1) return 0;
  if (fraction >= 2 / 3) return 0.33;
  if (fraction >= 1 / 3) return 0.66;
  return 1;
}

/** Effective baseline crutch opacity: most-faded of the reading axis and (when the
 *  challenge toggle is on) the memory axis. min of two rungs is a rung. */
export function combinedBaseline(reading: number, memory: number, challengeOn: boolean): number {
  return Math.min(reading, challengeOn ? memory : 1);
}
